import React from 'react';
import EmailSentRoute from './EmailSentRoute';

const AgentEmailSentRoute: React.FC = () => {
  return <EmailSentRoute />;
};

export default AgentEmailSentRoute;
